import { BRAND } from './styles';

// Backend sözleşmesi (dondurulmuş): offerAcceptanceRate / slaBreach[].rate /
// sources[].conversionRate / interviewHealth.noShowRate / .cancelRate hepsi
// payda sıfırken `null` döner (0 DEĞİL). Ekranda null → "—", asla "%0".
// Varsayım: rate alanları 0-1 arası kesir (backend henüz yok — bkz. rapor).
export function formatPercent(rate, locale = 'tr-TR', digits = 0) {
  if (rate === null || rate === undefined) return '—';
  return `%${(rate * 100).toLocaleString(locale, {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  })}`;
}

export function formatNumber(value, locale = 'tr-TR', digits = 0) {
  if (value === null || value === undefined) return '—';
  return Number(value).toLocaleString(locale, { minimumFractionDigits: digits, maximumFractionDigits: digits });
}

// SLA ihlal oranı yükseldikçe uyarı rengi (brief). Eşikler mockup/histogram
// bantlarıyla aynı üçlü mantık: düşük=iyi, orta=uyarı, yüksek=kritik.
// rate `null` ise (payda sıfır) nötr gri — bar zaten 0 yükseklikte render
// olur, gerçek anlam etikette ("—") taşınır.
export function slaBreachColor(rate) {
  if (rate === null || rate === undefined) return BRAND.muted;
  if (rate >= 0.6) return BRAND.danger;
  if (rate >= 0.3) return BRAND.warning;
  return BRAND.primary;
}

// Saat değerini kısa okunur birime çevirir (>=48s → gün, aksi halde saat).
// Sadece görüntüleme amaçlı; medyan/p75 ham veri saat olarak kalır.
export function formatHours(hours, locale = 'tr-TR') {
  if (hours === null || hours === undefined) return '—';
  if (hours >= 48) {
    return `${(hours / 24).toLocaleString(locale, { maximumFractionDigits: 1 })} g`;
  }
  return `${Number(hours).toLocaleString(locale, { maximumFractionDigits: 1 })} sa`;
}
